import React, { Component, ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { Logo } from '@/components/common/logo'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Erro capturado pelo ErrorBoundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-shell flex flex-col items-center justify-center min-h-screen text-center px-4">
          <div className="mb-8">
            <Logo size="lg" showText />
          </div>

          <div className="max-w-md w-full bg-card border border-border/50 rounded-3xl p-10 shadow-elevated flex flex-col items-center gap-4">
            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-destructive/15 text-destructive">
              <AlertTriangle className="h-8 w-8" />
            </div>

            <div className="space-y-1">
              <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Erro inesperado</span>
              <h1 className="text-2xl font-bold text-foreground">Algo deu errado</h1>
              <p className="text-sm text-muted-foreground max-w-sm mx-auto mt-2">
                Houve um problema ao carregar essa página.
              </p>
              {this.state.error?.message && (
                <p className="mt-2 text-xs font-mono text-muted-foreground bg-muted/60 rounded-md px-3 py-2 break-words">
                  {this.state.error.message}
                </p>
              )}
            </div>

            <button
              onClick={() => window.location.reload()}
              className="mt-2 inline-flex items-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 font-semibold px-6 py-2.5 rounded-md shadow-soft transition-colors"
            >
              <RefreshCw className="h-4 w-4" />
              Recarregar página
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
